const dataExample = {
  name: 'nivo',
  children: [
    {
      name: 'colors',
      children: [
        {
          name: 'rgb',
          value: 127767,
        },
        {
          name: 'hsl',
          value: 105860,
        },
      ],
    },
    {
      name: 'utils',
      children: [
        {
          name: 'randomize',
          value: 57395,
        },
        {
          name: 'resetClock',
          value: 143372,
        },
        {
          name: 'noop',
          value: 113055,
        },
      ],
    },
    {
      name: '18-24',
      children: [
        {
          name: 'male',
          value: 71555,
        },
        {
          name: 'female',
          value: 136201,
        },
        {
          name: 'unknown',
          value: 172484,
        },
      ],
    },
    {
      name: '25-30',
      children: [
        {
          name: 'male',
          value: 71555,
        },
        {
          name: 'female',
          value: 136201,
        },
        {
          name: 'unknown',
          value: 172484,
        },
      ],
    },
  ],
};

export default dataExample;
